import type { LiveBreakHost } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import type { ExtraSegment, OtherKind } from "../../core/primitives/lineup";
import { type FormStatus, idleForm, idleLoad, type LoadStatus } from "../../core/primitives/load-status";

/** `go-live` opens a stream with what is picked; `add` appends to one that is open. */
export type PickerMode = "go-live" | "add";

export class LineupPickerState {
  readonly open = new Rx(false);
  readonly mode = new Rx<PickerMode>("add");
  /** The shop's boxes on sale in no line-up. */
  readonly boxes = new RxList<LiveBreakHost>();
  readonly boxesStatus = new Rx<LoadStatus>(idleLoad);
  /** Box ids in the order they were picked, which is the order they join. */
  readonly picked = new Rx<readonly string[]>([]);
  readonly extras = new Rx<readonly ExtraSegment[]>([]);
  readonly extraDraft = new Rx<ExtraSegment>({ kind: "UNBOXING", title: "" });
  /** Where a new stream broadcasts from; only asked when the shop has more than one. */
  readonly locations = new Rx<readonly { id: string; name: string }[]>([]);
  readonly locationId = new Rx<string | null>(null);
  readonly submit = new Rx<FormStatus>(idleForm);
}

export abstract class LineupPickerActions {
  abstract show(mode: PickerMode): void;
  abstract close(): void;
  abstract toggleBox(breakId: string): void;
  abstract setExtraKind(kind: OtherKind): void;
  abstract setExtraTitle(title: string): void;
  abstract addExtra(): void;
  abstract removeExtra(index: number): void;
  abstract selectLocation(locationId: string): void;
  abstract confirm(): Promise<void>;
  /** Go live with nothing picked; segments are added from the cockpit. */
  abstract skip(): Promise<void>;
}
